import React from 'react';
import ziyodulla from '../Images/Qasim.png';


const Baxtiyor = () => {
    return (
        <div style={{color: 'black'}}>
            <div className='container text-start'>
                <div className='row'>
                    <div className='col-10'>
                        <h1 className='text-center'>МАЪЛУМОТНОМА</h1>
                        <h2 className='text-center'>Рахимов Касим Каримович</h2>
                        <p>2020 йил 2 сентябрдан:</p>
                        <p>Чилонзор туман 2-сон касб-ҳунар мактабининг - Молия иқтисод ишлари бўйича директор ўринбосари</p>
                    </div>   
                    <div className='col-2'>
                        <img src={ziyodulla} />
                    </div>    
                </div> 
                <div className='row'>
                    <div className='col'>
                        <p className='h5'>Туғилган йили:</p>
                        <p>02.05.1963</p>
                        <p className='h5'>Миллати:</p>
                        <p>ўзбек</p>
                        <p className='h5'>Маълумоти:</p>
                        <p>олий</p>
                        <p className='h5'>Маълумоти бўйича мутахассислиги:</p>
                        <p className='h5'>Илмий даражаси:</p>
                        <p>йўқ</p>
                        <p className='h5'>Қайси чет тилларини билади:</p>
                        <p>рус тили</p>
                        <p className='h5'>Давлат мукофотлари билан тақдирланганми (қанақа):</p>
                        <p>йўқ</p>
                        <p className='h5'>Халқ депутатлари, республика, вилоят, шаҳар ва туман Кенгаши депутатими ёки бошқа
сайланадиган органларнинг аъзосими (тўлиқ кўрсатилиши лозим)	</p>
                        <p>йўқ</p>
                    </div>
                    <div className='col'>
                    <p className='h5'>Туғилган жойи:</p>
                        <p>Тошкент вилояти, Янгийўл тумани</p>
                        <p className='h5'>Партиявийлиги:</p>
                        <p>йўқ</p>
                        <p className='h5'>Тамомлаган:</p>
                        <p>1991 й. Тошкент ирригация ва қишлоқ хўжалиги механизациялаштириш инженерлари институти (кундузги)</p>
                        <p>техник, қишлоқ хўжалик фанлари бўйича инженер ўқитувчи</p>
                        <p className='h5'>Илмий унвони:</p>
                        <p>йўқ</p>
                        <p className='h5'>Ҳарбий (махсус) унвони:</p>
                        <p>йўқ</p>
                    </div>
                </div>
                <p className='h3'>МЕҲНАТ ФАОЛИЯТИ</p>
                <p>1981-1981 йй. - CУ-1 "Стройтермоизоляция"нинг - ишчи</p>
                <p>1981-1983 йй. - НТ № 9003501 қисмнинг - Харбий хизматда</p>
                <p>1983-1984 йй. - №159-қурилиш трести 8-қурилиш участкаси</p>
                <p>1984-1988 йй. - Тошкент ирригация ва қишлоқ хўжалиги механизациялаштириш инженерлари институтининг  - талаба</p>
                <p>1988-1993 йй. - 50-ҳунар-техника билим юртининг - ишлаб чиқариш устаси</p>
                <p>1993-2001 йй. - 50-ҳунар-техника билим юртининг - II-тоифали ишлаб чиқариш устаси</p>
                <p>2001-2003 йй. - 50-ҳунар-техника билим юртининг - Маънавият ва маданият ишлари бўлими раҳбари мовуни</p>
                <p>2003-2005 йй. - Тошкент банк ҳисоб-кредит коллежининг - биноларни таъмирлаш бўйича муҳандис</p>
                <p>2005-2006 йй. - Тошкент банк ҳисоб-кредит коллежининг - Хўжалик ишлари бўйича директори ўринбосари вазифасини вақтинча бажарувчи</p>
                <p>2006-2020 йй. - Тошкент банк ҳисоб-кредит коллежининг - Хўжалик ишлари бўйича директор ўринбосари</p>
                <p>2020 й. -  ҳ.в.  - Чилонзор туман 2-сон касб-ҳунар мактабининг - Молия иқтисод ишлари бўйича директор ўринбосари</p>
                    <br />
                <p className='h2'>Малумотнома паспорт, диплом ва меҳнат дафтарчасига асосан тўғри ёзилган</p>
                <div className='row'>
                    <div className='col'>
                        <p className='h4'>КҲМ директори:</p>
                        <p className='h4'>Кадрлар бўйича инспектори:</p>
                    </div>
                    <div className='col'>
                        <p className='h4'>  Б.И.Тўйинов</p>
                        <p className='h4'>  Ш.А.Райимқулов  </p>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Baxtiyor;